'use client';

import Image from 'next/image';
import { LangLink } from '../../../i18n/links';
import WorkspaceCTA from '../../v2/WorkspaceCTA';

export default function SolutionHero({ title, description, image, solutionsLabel }) {
  return (
    <section className="single-blog-v2-hero solution-v2-hero">
      <div className="container blog-v2-container">
        <nav className="single-blog-v2-breadcrumb" aria-label="Breadcrumb">
          <LangLink to="/solutions">{solutionsLabel}</LangLink>
          <span aria-hidden="true">/</span>
          <span>{title}</span>
        </nav>
        <h1>{title}</h1>
        <p className="single-blog-v2-deck">{description}</p>
        <WorkspaceCTA compact />
        <div className="single-blog-v2-hero-image">
          <Image src={image} alt={title} fill priority sizes="(max-width: 1200px) 100vw, 1160px" />
        </div>
      </div>
    </section>
  );
}
